module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-6.740e5082.svg";